module.exports = __webpack_public_path__ + "img/avatar-man.0fc498b8.png";